import TeamsOrganizer from "../components/teams/TeamsOrganizer"
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ApiService } from "services/ApiService";

const TeamsPage: React.FC = () => {
    const artistId = useParams<string>();
    const [teamId, setTeamId] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchTeamId = async () => {
            var response = await ApiService.getTeamAsync('', artistId.artistId ?? '');

            if (!response || !response.data || !response.data.teamId) {
                console.log("No team found for this artist");
                setTeamId('');
                setLoading(false);
                return;
            }

            // Set the teamId from the response data
            setTeamId(response.data.teamId);
            setLoading(false);
        };
        fetchTeamId();
    }, [artistId]);

    if (loading){
        return <h2>Loading...</h2>;
    }
    if (!artistId){
        return <h2>Not found!</h2>
    }

    if (!teamId){
        console.log("not found");
        return <h2>Not found!</h2>
    }

    return <>
        <TeamsOrganizer teamId={teamId} />
    </>
}

export default TeamsPage;